import LeadListsHandler from './components/LeadListsHandler'
export default LeadListsHandler
